__turbopack_context__.v({
  "checkmark": "puckkq_checkmark",
  "filled": "puckkq_filled",
  "label": "puckkq_label",
  "ratingContainer": "puckkq_ratingContainer",
  "star": "puckkq_star",
  "stars": "puckkq_stars",
  "text": "puckkq_text",
  "toggleContainer": "puckkq_toggleContainer",
});
